<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header
                :menu-listing="filteredMenuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import resource from '@/api/resource';
const modulesApi = new resource('configurations/modules');

export default {
    data() {
        return {
            menuListing: [
                {
                    anchorLink: '/configuration/',
                    menuLabel: 'Idenfo Engine',
                    name: 'idenfo-engine',
                    permission: ['idenfo-engine'],
                },
                {
                    anchorLink: '/configuration/screening-data/',
                    menuLabel: 'Screening Data',
                    name: 'gender',
                    permission: ['view-screening-data'],
                },
                {
                    anchorLink: '/configuration/form-builder/',
                    menuLabel: 'Form Builder',
                    name: 'form-builder-setup-profile',
                    permission: ['form-builder'],
                },
                {
                    anchorLink: '/configuration/simulate/',
                    menuLabel: 'Simulate',
                    name: 'initiate-simulation-process',
                    permission: ['initiate-simulation-process'],
                },
                {
                    anchorLink: '/configuration/on-boarding-configuration/',
                    menuLabel: 'On Boarding Configuration',
                    name: 'on-boarding-configuration',
                    permission: ['onboarding-configurations'],
                },
                {
                    anchorLink: '/configuration/labeling/',
                    menuLabel: 'Labelling',
                    name: 'labeling',
                    permission: ['white-labelling'],
                },
                {
                    anchorLink: '/configuration/branding/',
                    menuLabel: 'Branding',
                    name: 'branding',
                    permission: ['branding'],
                },
                {
                    anchorLink: '/configuration/screening-list/',
                    menuLabel: 'Screening List Categorisation',
                    name: 'screening-list',
                    permission: ['screening-list'],
                },
                {
                    anchorLink: '/configuration/idv-configuration',
                    menuLabel: 'SDK Configuration',
                    name: 'idv-configurations',
                    permission: ['idv-configurations'],
                },
                {
                    anchorLink: '/configuration/packages/',
                    menuLabel: 'Manage Packages',
                    name: 'packages',
                    permission: ['manage-packages'],
                },
            ],
            modulesData: null,  // Initialize modulesData to store fetched data
        };
    },

    computed: {
        ...mapGetters(['user']),
        dataValue() {
            if (!this.modulesData) {
                this.fetchModulesData();
            }
            return this.modulesData;
        },
        
        // Computed property to filter menu items based on user.idv value
        filteredMenuListing() {
            if (this.modulesData) {
                return this.filterMenuByIdv(this.menuListing, this.user,this.modulesData);
            } else {
                return this.menuListing;
            }
        },
    },

    async mounted() {
        // Additional logic can be added here
        if (this.user.roleName === 'Super Admin') {
            this.$router.push({ name: 'idenfo-engine' });
        }
        this.fetchModulesData();
    },

    methods: {
        // Method to fetch modules data
        async fetchModulesData() {
            try {
                let { data } = await modulesApi.list({
                    dataSegmentId: this.user.dataSegmentIds[0],
                });
                this.modulesData = data;  // Store the fetched data
                console.log("Modules Data:", this.modulesData);
            } catch (error) {
                console.error("Error fetching modules data:", error);
            }
        },

        // Custom method to filter the menu based on user.idv
        filterMenuByIdv(menuItems, user,data) {
            console.log("User's Data Segment ID:", user.dataSegmentIds[0]);

            return menuItems.filter((menuItem) => {
                // Only show 'idv-configuration' if user.idv is true
                console.log("User IDV:", data.data.idv);
                return !(menuItem.name === 'idv-configurations' && !data.data.idv);
            });
        },

        // Additional custom logic can be added here as needed
        someOtherLogic() {
            // For example, handling user permissions or other conditions
            if (this.user.permissionLevel >= 2) {
                console.log('User has access to advanced features.');
            }
        }
    },
};
</script>
